export default "__VITE_ASSET__CW0pi6gp__"